import CustomSelect from 'components/CustomSelect'
import { httpOk, PATCH } from 'helpers/api'
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

const initData = {
	warehouse_id: '',
	priority: 'low',
	comment: '',
	items: []
}

function ApplicationProcessing({ modal, setModal, item, getData }) {
	const { t } = useTranslation()

	const [sendData, setSendData] = useState(structuredClone(initData))

	async function create() {
		var sendDataCopy = { ...sendData }
		const response = await PATCH(`/procurement/requests/${sendData.id}/procurement/`, sendDataCopy)
		if (httpOk(response)) {
			setModal(false);
			setSendData(structuredClone(initData))
			getData()
		}
	}

	function handleChange(e) {
		var sendDataCopy = { ...sendData };
		sendDataCopy[e.target.name] = e.target.value;
		setSendData(sendDataCopy);
	}

	function handleChangeItem(e, index) {
		var sendDataCopy = { ...sendData };
		sendDataCopy.items[index][e.target.name] = e.target.value;
		setSendData(sendDataCopy);
	}

	useEffect(() => {
		if (modal) {
			console.log(item);
			setSendData({ ...item })
		} else {
			setTimeout(() => {
				setSendData(structuredClone(initData));
			}, 100);
		}
	}, [modal, item]);

	return (
		<>
			<Modal show={modal} centered onHide={() => setModal(false)}>
				<i className="uil-times" onClick={() => setModal(false)}></i>
				<div className="modal-title mb-12">
					{t('application_processing')}
				</div>
				<div className="modal-subtitle mb-32">
					{t('enter_supplier_and_cost_details')}
				</div>

				<div className="d-flex flex-column gap-16 mb-32">
					<div className="form-group">
						<label>{t('comment')}</label>
						<input type="text" placeholder={t('additional_info')} name='comment'
							value={sendData.comment} onChange={(e) => handleChange(e)} />
					</div>

					<div className="card forth">
						<div className="d-between mb-16">
							<div>
								{t('ordered_items')}
							</div>
						</div>

						<div className="d-flex flex-column gap-12">
							{sendData?.items?.map((item, index) => (
								<div className="d-flex gap-8" key={index}>
									<div style={{ minWidth: '230px', }}>
										<CustomSelect
											value={{ name: item.raw_material_name }}
											getOptionLabel={(option) => option.name}
											placeholder={t('sku')}
											isDisabled={true}
										/>
									</div>

									<input type="text" placeholder={t('unit_price')} name="unit_price" className="w-100"
										value={item.unit_price} onChange={(e) => handleChangeItem(e, index)} />
								</div>
							))}
						</div>
					</div>
				</div>

				<div className="modal-footer">
					<button className="white" onClick={() => setModal(false)}>
						{t('cancel')}
					</button>
					<button className="dark" onClick={create}>
						{t('confirm_procurement')}
					</button>
				</div>
			</Modal>
		</>
	)
}

export default ApplicationProcessing